module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo07-4529c8d76644596a8bc58b338d58966d.png";